import Joi from 'joi';

/**
 * Schema for legal age validation.
 * @param legalAge - The legal age to be used for validation.
 * @returns - A Joi date schema object. In case the value is invalid,
 * it will return an error message with the key 'age.underage'.
 */
export const legalAgeSchema = (legalAge: number) =>
	Joi.date()
		.less('now')
		.required()
		.custom((value, helpers) => {
			const birthDate = new Date(value);
			let age = new Date().getFullYear() - birthDate.getFullYear();
			const monthDifference = new Date().getMonth() - birthDate.getMonth();
			const dayDifference = new Date().getDate() - birthDate.getDate();

			if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
				age--;
			}

			if (age < legalAge) {
				return helpers.error('age.underage');
			}

			return value;
		});
